import { createI18n } from 'vue-i18n'
import zhCN from '../locales/zh-CN.json'
import enUS from '../locales/en-US.json'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'

// 语言包配置
const messages = {
  'ZH': zhCN,
  'EN': enUS
}

// Element Plus 语言包配置
const elementPlusLocales = {
  'ZH': zhCn,
  'EN': en
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'ZH', // 默认语言
  fallbackLocale: 'EN', // 回退语言
  messages
})

// 更新文档标题
function updateDocumentTitle() {
  const locale = i18n.global.locale.value
  const title = messages[locale]?.title?.name1 || messages['ZH'].title.name1
  if (title) {
    document.title = title
  }
}

// 语言切换函数
export function setLocale(locale) {
  i18n.global.locale.value = locale
  localStorage.setItem('user-locale', locale)
  
  // 同时切换 Element Plus 语言
  const elementLocale = elementPlusLocales[locale]
  if (elementLocale) {
    // 存储 Element Plus 语言配置到 localStorage
    localStorage.setItem('element-plus-locale', JSON.stringify(elementLocale))
  }
  
  // 更新文档标题
  updateDocumentTitle()
}

// 获取当前 Element Plus 语言配置
export function getElementPlusLocale() {
  const savedLocale = localStorage.getItem('element-plus-locale')
  if (savedLocale) {
    try {
      return JSON.parse(savedLocale)
    } catch (e) {
      console.warn('Failed to parse element-plus locale from localStorage', e)
    }
  }
  
  // 如果没有保存的配置，根据当前语言返回对应的语言包
  const currentLocale = getLocale()
  return elementPlusLocales[currentLocale] || zhCn
}

// 获取当前语言
export function getLocale() {
  return i18n.global.locale.value
}

// 获取所有支持的语言
export function getSupportedLocales() {
  return [
    { code: 'ZH', name: '中文' },
    { code: 'EN', name: 'English' }
  ]
}

// 初始化语言设置
export function setupI18n() {
  const savedLocale = localStorage.getItem('user-locale')
  if (savedLocale && messages[savedLocale]) {
    i18n.global.locale.value = savedLocale
  }

  // 设置浏览器语言检测
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang && !savedLocale) {
    if (browserLang.startsWith('zh')) {
      i18n.global.locale.value = 'ZH'
    } else if (browserLang.startsWith('en')) {
      i18n.global.locale.value = 'EN'
    } else {
      i18n.global.locale.value = 'ZH'
    }
  }
  
  // 初始化 Element Plus 语言配置
  const currentLocale = getLocale()
  const elementLocale = elementPlusLocales[currentLocale] || zhCn
  localStorage.setItem('element-plus-locale', JSON.stringify(elementLocale))
  
  // 更新文档标题
  updateDocumentTitle()
}

export default i18n